import "../CSR/csr.scss";
import { allImages } from "../../services/images";
import { Heading } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
import { useRef, useEffect, useState } from "react";
import { SetGallery } from "../Gallery/imageViewer";
import { Helmet } from "react-helmet-async";
export default function CSR() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    const [tab, setTab] = useState(0);
    const sectionref = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        const timer = setTimeout(() => {
            sectionref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 2000);
        return () => clearTimeout(timer);
    }, [])
    var csrs = [
        {
            year: "2024-25",
            csr: [
                {
                    heading: "Water pipeline Connection",
                    content: "Water project at Gatha Panuku & Konda Jilugu, with a budget of Rs. 148,774, will lay water pipelines to deliver clean water to homes and public institutions, improving health, supporting education, and enhancing daily life, encouraging further infrastructure investments.",
                    img: [
                        { image: allImages.gcsr.csr2025.water[1] },
                        { image: allImages.gcsr.csr2025.water[2] },
                        { image: allImages.gcsr.csr2025.water[3] },
                        { image: allImages.gcsr.csr2025.water[4] }
                    ]
                },
                {
                    heading: "Skill Development",
                    content: "Organized a successful skills training program in Chodavaram mandal, providing valuable opportunities for 40 rural unemployed youth to secure jobs and improve their livelihoods. The initiative received appreciation from local leaders and aims to empower villages through ongoing education, employment training, and self-employment support. Collaborative efforts with community organizations have strengthened rural youth development and social welfare.",
                    img: [
                        { image: allImages.gcsr.csr2025.skill[1] },
                        { image: allImages.gcsr.csr2025.skill[2] },
                        { image: allImages.gcsr.csr2025.skill[3] }
                    ]
                },
                {
                    heading: "Library Establishment",
                    content: "The library was repaired and maintained in Chodavaram under the supervision of our Managing Director, Rajesh. Books were distributed, the library was organized, and a librarian was appointed. He was also felicitated by the locals for his efforts.",
                    img: [
                        { image: allImages.gcsr.csr2025.library[1] },
                        { image: allImages.gcsr.csr2025.library[2] },
                        { image: allImages.gcsr.csr2025.library[3] },
                        { image: allImages.gcsr.csr2025.library[4] }
                    ]
                }
            ],
        },
        {
            year: "2023-24",
            csr: [
                {
                    heading: "School",
                    content: "Our company is dedicated to improving communities through CSR initiatives, recently spending Rs. 127,952 on repairs on school, distributing notebooks, stationary items, storybooks, and sports equipment like carrom boards, cricket bats, and tennis balls in Kamugedda ASR District. This initiative aims to support students' educational and recreational needs, alleviating financial burdens on families and schools.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                },
                {
                    heading: "Conducting Medical camp",
                    content: "The medical camp at HPCL, Sheela Nagar, was a noteworthy CSR initiative aimed at providing essential health services to the community. Comprehensive health checkups, medical consultations by qualified professionals, and free spectacles distribution were among the services offered. The camp, which incurred a total expenditure of Rs. 87,300, ensured that individuals received necessary healthcare.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                },
                {
                    heading: "Solar project",
                    content: "The solar project at Prema samajam Chodavaram in Visakhapatnam is a significant initiative under corporate social responsibility (CSR), aimed at harnessing solar energy for a sustainable and reliable power supply. With a CSR expenditure of Rs. 6,10,000, the project underscores the company's commitment to environmental sustainability and social welfare. The initiative has greatly benefited the community by providing energy independence, reducing the carbon footprint, and offering economic savings through lower electricity bills.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                },
                {
                    heading: "Water pipeline",
                    content: "The water pipeline project in Arjapuram ASR district, with a budget of Rs. 103,682, aims to address water scarcity by providing clean water to households, schools, and healthcare facilities, reflecting the company's CSR commitment.",
                    img: [
                        { image: allImages.gcsr.water['1'] },
                        { image: allImages.gcsr.water['2'] },
                        { image: allImages.gcsr.water['3'] },
                    ]
                },
                {
                    heading: "Water pipeline",
                    content: "In Nerolla and Jilugulapadu, ASR district, a Rs. 175,161 project will install pipelines to ensure steady potable water, reducing waterborne diseases and saving families time and effort, which supports sustainable development.",
                    img: [
                        { image: allImages.gcsr.water['1'] },
                        { image: allImages.gcsr.water['2'] },
                        { image: allImages.gcsr.water['3'] },
                    ]
                },
                {
                    heading: "Water pipeline",
                    content: "The Devapuram project in ASR district, with a budget of Rs. 146,350, will lay pipelines to deliver clean water to homes and public institutions, improving health, supporting education, and enhancing daily life, encouraging further infrastructure investments.",
                    img: [
                        { image: allImages.gcsr.water['1'] },
                        { image: allImages.gcsr.water['2'] },
                        { image: allImages.gcsr.water['3'] },
                    ]
                }
            ]
        },
        {
            year: "2022-23",
            csr: [

                {
                    heading: "Water pipeline Connection",
                    content: "As part of its Corporate Social Responsibility (CSR) initiatives, PBL implemented a water pipeline connection to Seekaypadu Village in Paderu, addressing the community's need for reliable water access. The project, which incurred an expenditure of ₹89,000, involved collaboration with local authorities and experts to ensure seamless installation. This initiative has significantly improved the villagers' quality of life and productivity by providing a sustainable water source.",
                    img: [
                        { image: allImages.gcsr.water['1'] },
                        { image: allImages.gcsr.water['2'] },
                        { image: allImages.gcsr.water['3'] },
                    ]
                },
                {
                    heading: "Repairs To School",
                    content: "As a part of Corporate Social Responsibility (CSR), a recent initiative undertook much-needed repairs to the school in Pedimpalem Village, incurring a total expenditure of ₹170,000. This project, reflecting a deep commitment to community and education, addressed critical issues such as leaking roofs, broken windows, and crumbling walls. Extensive repairs were carried out to create a safer, more motivating learning environment, including window replacements, wall restoration, classroom upgrades, and sanitation facility improvements.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                },
                {
                    heading: "Distribution Of Accessories For Students",
                    content: "As part of a CSR initiative, various educational and sports items were distributed in government schools of Macherlapalem, Chekaipadu, Raipalem, and Ayyanadu. The aim was to support education and promote physical well-being among the children. Distribution included notebooks, storybooks, and sports equipment such as footballs, cricket sets, and badminton rackets.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                },
                {
                    heading: "Medical Camp Kurmanpalem",
                    content: "As part of our CSR initiatives, a medical camp was held at Kurmanpalem in Gajuwaka to provide essential healthcare services to the local community. The camp offered free medical consultations, health check-ups, and distributed medications.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                },
                {
                    heading: "Medical Camp Lankelapalem",
                    content: "As part of our CSR initiatives, a medical camp was held at Lankelapalem, Gateway CFS, to provide essential healthcare services to the local community. The camp offered free medical consultations, health check-ups, and distributed medications.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                },
                {
                    heading: "Distribution Of Accessories For Students Pedimpalem",
                    content: "Our company is dedicated to improving communities through CSR initiatives, recently spending on repairs on school, distributing notebooks, stationary items, storybooks, and sports equipment like carrom boards, cricket bats, and tennis balls in Pedimpalem & Seemulapalli. This initiative aims to support students' educational and recreational needs, alleviating financial burdens on families and schools.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                },
                {
                    heading: "Water pipeline Connection Gatha Panuku",
                    content: "Water project at Gatha Panuku & Konda Jilugu, with a budget of Rs. 148,774, will lay water pipelines to deliver clean water to homes and public institutions, improving health, supporting education, and enhancing daily life, encouraging further infrastructure investments.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                }
            ]
        },
        {
            year: "2021-22",
            csr: [
                {
                    heading: "Donation to PMNRF",
                    content: "Contribution of Rs. 5,53,000 to the Prime Minister's National Relief Fund as part of our Corporate Social Responsibility (CSR) initiatives. This contribution underscores our dedication to supporting national endeavors and providing assistance to those in need during challenging times.",
                    img: [
                        { image: allImages.gcsr.school['1'] },
                        { image: allImages.gcsr.school['2'] },
                        { image: allImages.gcsr.school['3'] },
                    ]
                }
            ]
        }
    ]
    return <div className="csr">
        <Helmet>
            <title>Corporate Social Responsibility - PBL Transport</title>
        </Helmet>
        <div className="banner">
            <div className="guard"></div>
            <div className="announce">
                <div className="content">
                    <div>Corporate</div>
                    <div>Social</div>
                    <div>Responsibility</div>
                </div>
                <img src={allImages.csr} alt="blog" />
            </div>
        </div>
        <div ref={sectionref}></div>
        <div className="csrs">
            <div className="messages" >
                <Heading heading="Corporate Social Responsibility" lightMode={lightMode} />
                <div className="tabs">
                    {csrs.map((item, i) => {
                        return <div className={`year ${i === tab ? "active" : "inactive"}`} onClick={() => setTab(i)}>{item.year}</div>
                    })}
                </div>
                {csrs[tab].csr.length === 0 ? <div className="comingsoon"><h1>Coming Soon</h1></div> :
                    <div className="tabdata">
                        {csrs[tab].csr.map((e, i) => {
                            return <div className="cardImage">
                                <img className="mainimg" src={e.img[0].image} alt="logo" />
                                <div className="guards">
                                    <div className="cont">
                                        <h2>{e.heading}</h2>
                                        {e.content}
                                        <div className="images">
                                            <SetGallery images={e.img} heading={""} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>}
            </div>
        </div>
    </div>
}